import styled from '@emotion/styled'
import { color, space, SpaceProps } from 'styled-system'
import { theme } from '../../../theme'

export const DatePickerSelect = styled.select<SpaceProps>`
  ${space};
  height: 36px;
  font-size: small;
`

export const DatePickerWrapper = styled.div`
  width: 100%;
  border-radius: 0.25rem;

  .DateInput {
    display: flex;
    width: 100%;
  }
  .DayPickerNavigation_button {
    border: none;
  }
  .CalendarDay {
    border: none;
    font-size: small;
  }
  .DateInput_input {
    ${color};
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    font-style: normal;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    transition: all 0.2s;
    outline: none;
    font-size: small;
    padding: 0 0.75rem;
    line-height: 2.5rem;
    border: none;
    background-color: ${theme.colors.gray[100]};
    font-size: small;
    border-color: transparent;
    &:disabled {
      opacity: 0.5;
    }
  }
  .DateInput_input__focused {
    border-color: transparent;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: ${theme.colors.brand[500]};
    border: none;
    color: #fff;
  }
  .SingleDatePicker {
    display: flex;
  }
  .SingleDatePicker_picker {
    z-index: 1700;
  }
  .SingleDatePicker > div,
  .SingleDatePicker > div > .SingleDatePickerInput {
    width: 100%;
  }
  .SingleDatePickerInput__withBorder {
    border: none;
    height: 40px;
  }
  .CalendarMonth_caption {
    padding-top: 16px;
  }
`
